const grid = document.querySelector("#product-grid");
if (grid) {
  const firstItem = grid.dataset.firstItem;
  const lastItem = grid.dataset.lastItem;
  const totalItems = grid.dataset.totalItems;

  const msg = `${firstItem}–${lastItem} of ${totalItems}`;
  console.log(msg);

  const count = document.querySelector("#ProductCount");
  if (count) {
    count.innerHTML = msg;
  } else {
    console.warn("No ProductCount element found");
  }
} else {
  console.warn("No product-grid element found");
}
